<template>
  <v-container fluid>
    <v-row column>
      <p class="text-body-1 mb-4">{{ $t('mal_the_accounts_below_were_found') }}</p>
    </v-row>
    <v-row>
      <div v-for="account in minorAccounts" :key="account.accountId">
        {{ account.firstName }}&nbsp;{{ account.lastName }}<br />
        {{ `$${account.totalMarketValue}` }}<br />
        {{ account.accountNumber }}<br />
      </div>
    </v-row>
    <v-row class="mt-4 justify-end">
      <v-col cols="12" sm="4" class="mb-3 ml-3">
        <OnexButton
          :disabled="disableActions"
          block
          color="primary"
          variant="outlined"
          @click="cancelAction"
        >
          Cancel
        </OnexButton>
      </v-col>
      <v-col cols="12" sm="4" class="mb-3 ml-3">
        <OnexButton :disabled="disableActions" block color="primary" @click="continueAction">
          Continue
        </OnexButton>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions, type PropType } from 'vue';
import { OnexButton } from '@primerica/onex-ui-lib';
import type { ICustodialAccountMeta } from '@/shared/api/models.bff';

const componentOptions: ComponentOptions = {
  name: 'MinorAccountLinkProcessInformationReview',
  components: {
    OnexButton,
  },
  props: {
    minorAccounts: {
      type: Array as PropType<ICustodialAccountMeta[]>,
      default: () => [],
    },
    disableActions: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    continueAction() {
      this.$emit('continueClicked', {});
    },
    cancelAction() {
      this.$emit('cancelClicked');
    },
  },
};

export default defineComponent(componentOptions);
</script>
